<!-- <p-treeTable [value]="treeData">
    <p-header>{{title}}</p-header>
    <p-column [styleClass]="'col-order'" field="order" header="Currency" [style]="{'width':'15%','text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.currency}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-location'" field="location" header="" [style]="{'text-align':'center'}"></p-column>
    <p-column [styleClass]="'col-day-one'" field="day1Amount" [header]="headerDates[0]" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.day1Amount)}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-two'" field="day2Amount" [header]="headerDates[1]" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.day2Amount)}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-three'" field="day3Amount" [header]="headerDates[2]" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.day3Amount)}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-four'" field="day4Amount" [header]="headerDates[3]" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.day4Amount)}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-five'" field="day5Amount" [header]="headerDates[4]" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.day5Amount)}}</span>
        </ng-template>
    </p-column>
</p-treeTable> -->
<p-table #fivedayladder class="five-day-ladder liquitics-compact-table" sortField="order" [value]="tableData" scrollable="true" selectionMode='single'
    [(selection)]="selectedRow" (onRowSelect)="onRowSelect($event)" [paginator]="false" scrollable="true" exportFilename="five-day-ladder"
    styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <span fxFlex="1 1 auto" fxFlexAlign="center">Five Day Ladder</span>
        <button fxFlex="0 0 auto" fxFlexAlign="right" type="button" pButton icon="fa fa-file-o" label="CSV"></button>
        <!-- (click)="fivedayladder.exportCSV()"  -->
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th> </th>
            <th>Actual</th>
            <th>Loc</th>
            <th>{{headerDates[0]}}</th>
            <th>{{headerDates[1]}}</th>
            <th>{{headerDates[2]}}</th>
            <th>{{headerDates[3]}}</th>
            <th>{{headerDates[4]}}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr>
            <td rowspan="2" [style]="{'width':'15%','text-align':'center'}">{{row.currency}}</td>
            <td rowspan="2" [style]="{'text-align':'center'}">
                <span>{{ row.actualAmount }}</span>
            </td>
            <td [style]="{'text-align':'center'}">
                <div fxLayout="column">
                    <span fxFlex="0 0 50%" class="location-data">{{locationName}}</span>
                    <span fxFlex="0 0 50%" class="other-data">Other</span>
                </div>
            </td>
            <td [style]="{'text-align':'center'}">
                <div fxLayout="column">
                    <span fxFlex="0 0 50%" class="location-data">{{round(row.day1LocationAmount) }}</span>
                    <span fxFlex="0 0 50%" class="other-data">{{round(row.day1OtherAmount)}}</span>
                </div>
            </td>
            <td [style]="{'text-align':'center'}">
                <div fxLayout="column">
                    <span fxFlex="0 0 50%" class="location-data">{{round(row.day2LocationAmount) }}</span>
                    <span fxFlex="0 0 50%" class="other-data">{{round(row.day2OtherAmount)}}</span>
                </div>
            </td>
            <td [style]="{'text-align':'center'}">
                <div fxLayout="column">
                    <span fxFlex="0 0 50%" class="location-data">{{round(row.day3LocationAmount) }}</span>
                    <span fxFlex="0 0 50%" class="other-data">{{round(row.day3OtherAmount)}}</span>
                </div>
            </td>
            <td [style]="{'text-align':'center'}">
                <div fxLayout="column">
                    <span fxFlex="0 0 50%" class="location-data">{{round(row.day4LocationAmount) }}</span>
                    <span fxFlex="0 0 50%" class="other-data">{{round(row.day4OtherAmount)}}</span>
                </div>
            </td>
            <td [style]="{'text-align':'center'}">
                <div fxLayout="column">
                    <span fxFlex="0 0 50%" class="location-data">{{round(row.day5LocationAmount) }}</span>
                    <span fxFlex="0 0 50%" class="other-data">{{round(row.day5OtherAmount)}}</span>
                </div>
            </td>
        </tr>
    </ng-template>




    <!-- <p-header fxLayout="row">
        <span fxFlex="1 1 auto" fxFlexAlign="center">Five Day Ladder</span>
        <button fxFlex="0 0 auto" fxFlexAlign="right" type="button"  (click)="fivedayladder.exportCSV()" pButton icon="fa fa-file-o" 
            label="CSV"></button>
    </p-header>

    <p-column [styleClass]="'col-order'" field="order" header="" [exportable]="false" [style]="{'width':'15%','text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{row.currency}}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-actual'" field="actualAmount" header="Actual" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <span>{{ row.actualAmount }}</span>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-currency'" field="currency" header="Currency" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-day1-location-amount'" field="day1LocationAmount" header="Day 1 Location Amount" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-day1-other-amount'" field="day1OtherAmount" header="Day 1 Other Amount" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-day2-location-amount'" field="day1LocationAmount" header="Day 2 Location Amount" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-day2-other-amount'" field="day1OtherAmount" header="Day 2 Other Amount" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-day3-location-amount'" field="day1LocationAmount" header="Day 3 Location Amount" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-day3-other-amount'" field="day1OtherAmount" header="Day 3 Other Amount" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-day4-location-amount'" field="day1LocationAmount" header="Day 4 Location Amount" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-day4-other-amount'" field="day1OtherAmount" header="Day 4 Other Amount" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-day5-location-amount'" field="day1LocationAmount" header="Day 5 Location Amount" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-day5-other-amount'" field="day1OtherAmount" header="Day 5 Other Amount" [hidden]="true"></p-column>
    <p-column [styleClass]="'col-location'" header="Loc" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <div fxLayout="column">
                <span fxFlex="0 0 50%" class="location-data">{{locationName}}</span>
                <span fxFlex="0 0 50%" class="other-data">Other</span>
            </div>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-one'" [header]="headerDates[0]" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <div fxLayout="column">
                <span fxFlex="0 0 50%" class="location-data">{{round(row.day1LocationAmount) }}</span>
                <span fxFlex="0 0 50%" class="other-data">{{round(row.day1OtherAmount)}}</span>
            </div>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-two'" [header]="headerDates[1]" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <div fxLayout="column">
                <span fxFlex="0 0 50%" class="location-data">{{round(row.day2LocationAmount)}}</span>
                <span fxFlex="0 0 50%" class="other-data">{{round(row.day2OtherAmount)}}</span>
            </div>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-three'" [header]="headerDates[2]" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <div fxLayout="column">
                <span fxFlex="0 0 50%" class="location-data">{{round(row.day3LocationAmount)}}</span>
                <span fxFlex="0 0 50%" class="other-data">{{round(row.day3OtherAmount)}}</span>
            </div>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-four'" [header]="headerDates[3]" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <div fxLayout="column">
                <span fxFlex="0 0 50%" class="location-data">{{round(row.day4LocationAmount)}}</span>
                <span fxFlex="0 0 50%" class="other-data">{{round(row.day4OtherAmount)}}</span>
            </div>
        </ng-template>
    </p-column>
    <p-column [styleClass]="'col-day-five'" [header]="headerDates[4]" [sortable]="false" [style]="{'text-align':'center'}">
        <ng-template let-row="rowData" pTemplate="body">
            <div fxLayout="column">
                <span fxFlex="0 0 50%" class="location-data">{{round(row.day5LocationAmount)}}</span>
                <span fxFlex="0 0 50%" class="other-data">{{round(row.day5OtherAmount)}}</span>
            </div>
        </ng-template>
    </p-column> -->
</p-table>